export const headerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
};

export const style = {
  textAlign: 'left',
  alignSelf: 'center',
};
